<template lang="pug">
  div#app
    router-view
</template>

<script>
export default {
  beforeCreate() {
    if (localStorage.getItem("firstVisit") !== "false") {
      this.$router.push("/help");
    }
  },
  mounted() {
    // ピンチアウトし拡大する事ができないように修正
    document.addEventListener(
      "touchstart",
      event => {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
    let lastTouch = 0;
    document.addEventListener(
      "touchend",
      event => {
        const now = window.performance.now();
        if (now - lastTouch <= 500) {
          event.preventDefault();
        }
        lastTouch = now;
      },
      true
    );
  }
};
</script>

<style lang="sass">
@font-face
  font-family: "Noto Sans CJK JP"
  font-weight: bold
  src: url("~@/assets/font/NotoSansCJKjp-Bold.otf")
@font-face
  font-family: "Noto Sans CJK JP"
  font-weight: normal
  src: url("~@/assets/font/NotoSansCJKjp-Medium.otf")

body
  background: #fbfbfb
  font-family: "Noto Sans CJK JP","Hiragino Kaku Gothic ProN","ヒラギノ角ゴ ProN W3","モリサワ 新ゴ R","Droid Sans","メイリオ","sans-serif";
  color: #53433e
  font-size: 2.1vmax
  margin: 0

*
  line-height: 1.5

button
  background: #53433e
  border: 2px solid #53433e
  border-radius: 3vmax
  color: white
  font-weight: bold
  width: 49vw
  height: 6vmax
  font-size: 2vmax

  &.negative
    background: inherit
    color: #53433e
</style>
